<template>
  <div class="swiper" @mouseenter="showSwipe" @mouseleave="closeSwipe">
    <div class="swiper-wrapper">
      <slot></slot>
    </div>
    <!-- <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div> -->
    <div slot="pagination" class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css'
export default {
  data() {
    return {
      swipe: null
    }
  },
  mounted() {
    this.swipe = new Swiper('.swiper', {
      direction: 'horizontal',
      loop: true,
      observer:true,
      observeParents:true,
      speed: 1500,
      grabCursor: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
    })
  },
  methods: {
    showSwipe() {
      this.swipe.autoplay.stop();
    },
    closeSwipe() {
      this.swipe.autoplay.start();
    }
  }
}
</script>

<style>
.swiper{
  --swiper-theme-color: #ff6600;
  --swiper-navigation-color: #fff;
  --swiper-navigation-size: 30px;
}
.swiper-button-prev:after, .swiper-button-next:after {
  font-size: 60px;
  left: 20px;
  opacity: 0.6;
}
.swiper-button-next:after {
  margin-right: 200px;
}
.swiper-button-prev:after {
  margin-left: 200px;
}
</style>
 